const TrainerRicerca = (props) => {
  const { ricercaAssociata } = props;

  function formatDateOnly(dateString) {
    if (!dateString) return "";

    const date = new Date(dateString);
    if (isNaN(date)) return "";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}.${month}.${year}`;
  }

  return (
    <div className="trainer-ricerca-associata">
      <div className="trainer-ricerca-associata-title">Ricerca Associata</div>
      <div className="trainer-data-fields">
        {ricercaAssociata ? (
          <div className="trainer-data">
            <div className="trainer-field-row">
              <div className="trainer-field-label">Titolo corso:</div>
              <div className="trainer-field-value">
                <span className="trainer-span-value">
                  {ricercaAssociata.titoloCorso}
                </span>
              </div>
            </div>

            <div className="trainer-field-row">
              <div className="trainer-field-label">Titolo modulo:</div>
              <div className="trainer-field-value">
                <span className="trainer-span-value">
                  {ricercaAssociata.titoloModulo}
                </span>
              </div>
            </div>

            <div className="trainer-field-row">
              <div className="trainer-field-label">Ore:</div>
              <div className="trainer-field-value">
                <span className="trainer-span-value">
                  {ricercaAssociata.ore}
                </span>
              </div>
            </div>

            <div className="trainer-field-row">
              <div className="trainer-field-label">Stato:</div>
              <div className="trainer-field-value">
                <span className="trainer-span-value">
                  {ricercaAssociata.statoRicerca}
                </span>
              </div>
            </div>
            <div className="trainer-field-row">
              <div className="trainer-field-label">Data Creazione:</div>
              <div className="trainer-field-value">
                <span className="trainer-span-value">
                  {formatDateOnly(ricercaAssociata.dataCreazione)}
                </span>
              </div>
            </div>
            <div className="trainer-field-row">
              <div className="trainer-field-label">Autore:</div>
              <div className="trainer-field-value">
                <span className="trainer-span-value">
                  {ricercaAssociata.autore}
                </span>
              </div>
            </div>
          </div>
        ) : (
          <div className="no-data">Nessuna ricerca associata.</div>
        )}
      </div>
    </div>
  );
};

export default TrainerRicerca;
